export const getContent = store => (store.order ? store.order : {});
export const get = store => {
  return getContent(store).order;
};
export const isLoaded = store => {
  let content = getContent(store);
  return content.isLoaded != null && content.isLoaded;
};
